module.exports = __webpack_public_path__ + "static/media/dial.eae28934.png";